import { useTheme } from "@mui/material";
import lightLogo from "./cadent-light.png";
import darkLogo from "./cadent-dark.png";

interface LogoProps {
  maxWidth?: string;
  maxHeight?: string;
}

export const Logo = ({ maxWidth = "130px", maxHeight = "40px" }: LogoProps) => {
  const theme = useTheme();

  return (
    <img
      src={theme.palette.mode === "dark" ? darkLogo : lightLogo}
      alt="Cadent Logo"
      style={{
        width: "100%",
        height: "auto",
        maxWidth,
        maxHeight,
      }}
    />
  );
};
